import PageNotFound from "./PageNotFound";

export default PageNotFound;



// WEBPACK FOOTER //
// ./src/page-not-found/index.ts